module.exports = __webpack_public_path__ + "static/container-2-67a2a3345a65a516de31999418a1b149.jpg";